import EntitySelector from './EntitySelector';

export default EntitySelector;
